import React from 'react';
import { XCircleIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';

const SubscriptionCancel: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full text-center">
        <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-100 dark:bg-red-900/20">
          <XCircleIcon className="h-8 w-8 text-red-600 dark:text-red-400" />
        </div>

        <h1 className="mt-6 text-3xl font-bold text-gray-900 dark:text-white">
          Subscription Canceled
        </h1>

        <p className="mt-4 text-gray-600 dark:text-gray-400">
          No worries! Your subscription process was canceled and no charges were made to your account.
        </p>

        <div className="mt-8 space-y-4">
          <Link
            to="/subscription"
            className="block w-full rounded-lg bg-mango-500 py-3 px-6 text-center text-sm font-medium text-white hover:bg-mango-600 transition-colors"
          >
            Try Again
          </Link>

          <Link
            to="/dashboard"
            className="block w-full rounded-lg border border-gray-300 dark:border-gray-600 py-3 px-6 text-center text-sm font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
          >
            Back to Dashboard
          </Link>
        </div>

        <div className="mt-8 p-4 bg-yellow-50 dark:bg-yellow-900/20 rounded-lg">
          <h3 className="text-sm font-medium text-yellow-800 dark:text-yellow-200">
            Need help deciding?
          </h3>
          <p className="mt-2 text-sm text-yellow-700 dark:text-yellow-300">
            Contact our support team if you have any questions about our subscription plans or features.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionCancel;